import {
  GET_TRANSFERHISTORY,
  GET_TRANSFERHISTORY_SUCCESS,
  GET_TRANSFERHISTORY_FAIL,
  DELETE_TRANSFERHISTORY,
  DELETE_TRANSFERHISTORY_SUCCESS,
  DELETE_TRANSFERHISTORY_FAIL,
  UPDATE_TRANSFERHISTORY,
  UPDATE_TRANSFERHISTORY_SUCCESS,
  UPDATE_TRANSFERHISTORY_FAIL,
  ADD_NEW_TRANSFERHISTORY,
  ADD_TRANSFERHISTORY_SUCCESS,
  ADD_TRANSFERHISTORY_FAIL,
  TRANSFERHISTORY_LOADING,
  TRANSFERHISTORY_RESET,
} from "./actionType";

export const resetTransferHistoryState = (actionType) => ({
  type: TRANSFERHISTORY_RESET,
  payload: { actionType },
});

export const getTransferHistorySuccess = (actionType, data) => ({
  type: GET_TRANSFERHISTORY_SUCCESS,
  payload: { actionType, data },
});

export const getTransferHistoryFail = (actionType, error) => ({
  type: GET_TRANSFERHISTORY_FAIL,
  payload: { actionType, error },
});

export const getTransferHistory = data => ({
  type: GET_TRANSFERHISTORY,
  payload: data,
});

export const getTransferHistoryLoading = () => ({
  type: TRANSFERHISTORY_LOADING
});

export const deleteTransferHistory = data => ({
  type: DELETE_TRANSFERHISTORY,
  payload: data,
});

export const deleteTransferHistorySuccess = data => ({
  type: DELETE_TRANSFERHISTORY_SUCCESS,
  payload: data,
});

export const deleteTransferHistoryFail = error => ({
  type: DELETE_TRANSFERHISTORY_FAIL,
  payload: error,
});

export const updateTransferHistory = data => ({
  type: UPDATE_TRANSFERHISTORY,
  payload: data,
});

export const updateTransferHistoryFail = error => ({
  type: UPDATE_TRANSFERHISTORY_FAIL,
  payload: error,
});

export const updateTransferHistorySuccess = data => ({
  type: UPDATE_TRANSFERHISTORY_SUCCESS,
  payload: data,
});

export const addNewTransferHistory = data => ({
  type: ADD_NEW_TRANSFERHISTORY,
  payload: data,
});

export const addTransferHistorySuccess = data => ({
  type: ADD_TRANSFERHISTORY_SUCCESS,
  payload: data,
});

export const addTransferHistoryFail = error => ({
  type: ADD_TRANSFERHISTORY_FAIL,
  payload: error,
});